import { render, staticRenderFns } from "./vetus-cliente.vue?vue&type=template&id=43ea057f&scoped=true"
import script from "./vetus-cliente.vue?vue&type=script&lang=js"
export * from "./vetus-cliente.vue?vue&type=script&lang=js"
import style0 from "./vetus-cliente.vue?vue&type=style&index=0&id=43ea057f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ea057f",
  null
  
)

export default component.exports